/**
 * Where a sign-in goes next, and what the reset link carries (spec 2026-09-30 akun 5),
 * DOM-free so the tests import it. GoTrue's implicit flow puts the recovery session in the
 * URL fragment (`#access_token=…&refresh_token=…&type=recovery`) and a spent or expired link
 * an error (`#error=access_denied&error_code=otp_expired…`).
 */
import type { LangkahMasuk } from '../../auth/session'

export function tujuanMasuk(langkah: LangkahMasuk): string {
  switch (langkah) {
    case 'buat_pin':
      return '/masuk/buat-pin'
    case 'unduhan':
      return '/masuk/unduhan'
    case 'beranda':
      return '/'
    case 'ganti_sandi':
      return '/masuk/sandi-awal'
    case 'dua_langkah':
      return '/masuk/dua-langkah'
  }
}

export type TautanPemulihan =
  /** A single-use link (the TokenHash template): its page spends the hash on Lanjutkan. */
  | { jenis: 'hash'; tokenHash: string }
  /** A link mailed before that template: GoTrue spent it and sent its session. */
  | { jenis: 'sesi'; accessToken: string; refreshToken: string }
  | { jenis: 'galat'; kode: string }
  | { jenis: 'kosong' }

export function bacaTautanPemulihan(hash: string): TautanPemulihan {
  const p = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash)
  const galat = p.get('error_code') ?? p.get('error')
  if (galat !== null) return { jenis: 'galat', kode: galat }
  const accessToken = p.get('access_token')
  const refreshToken = p.get('refresh_token')
  if (accessToken !== null && refreshToken !== null && p.get('type') === 'recovery') {
    return { jenis: 'sesi', accessToken, refreshToken }
  }
  return { jenis: 'kosong' }
}
